import { Div, Icon, Label, Loader, Touchable, useWindowSize } from "@grassrootly/rn-core";
import { MyGroupsListProps } from "./MyGroups.types";
import { Image, ScrollView } from "react-native";
import { images } from "../../layout/assets";
import moment from "moment";

export default function MyGroupsList({ loading, groups, onGroupPress }: MyGroupsListProps) {
  const { width } = useWindowSize();
  return (
    <Div classNames={["flex1"]}>
      {loading && !groups?.length ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}
      {!loading && groups && !groups.length ? (
        <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mt-{30}"]}>
          You are not member of any team - yet!
        </Label>
      ) : null}

      <ScrollView>
        {groups
          ? groups
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((group) => {
                return (
                  <Touchable
                    classNames={[
                      "bw-{0}",
                      "borderPrimary",
                      "flex1",
                      // width > 720 ? "flexRow" : "",
                      // width > 720 ? "alignItemsCenter" : "alignItemsFlexStart",
                      "alignItemsCenter",
                      "flexRow",
                      "br-{16}",
                      width > 720 ? "ph-{12}" : "",
                      width > 720 ? "pt-{16}" : "",
                      width > 720 ? "pb-{16}" : "",
                      width > 720 ? "" : "p-{10}",
                      "mv-{8}",
                      "bgSecondaryMain",
                    ]}
                    key={group.id}
                    onPress={() => onGroupPress(group.id)}
                  >
                    <Div classNames={["flexRow"]}>
                      <Image
                        source={group.group_logo ? { uri: group.group_logo } : images.groupAvatar}
                        style={{ width: 40, height: 40, borderRadius: 40 }}
                      />
                      <Div classNames={["ml-{8}"]}>
                        <Label numberOfLines={3}>{group.name}</Label>
                        <Label type="l4Regular">Active since: {moment(group.created_at).format("DD.MM.YYYY")}</Label>
                      </Div>
                    </Div>
                    {group.is_owner ? (
                      <Div classNames={["ml-{auto}", width > 720 ? "p8" : ""]}>
                        <Icon classNames={["colorNeutralLighterLight"]} size={25} name="admin_panel_settings" />
                      </Div>
                    ) : null}
                  </Touchable>
                );
              })
          : null}
      </ScrollView>
    </Div>
  );
}
